import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 37771 34934"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:546.026}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528122749072">
        <path
          d="M35279 1670H2398c-142 0-258-115-258-257 0-143 115-258 258-258h32881c142 0 257 115 257 258 0 142-115 257-257 257z"
          className="fill stroke1"
          style={{
            strokeWidth: 546.026,
          }}
        />
        <path
          d="M1414 788c-345 0-625 281-625 625s280 624 624 624c345 0 624-280 624-624s-280-625-623-625zm0 1764c-629 0-1141-511-1141-1139 0-629 512-1140 1140-1140 629 0 1140 511 1140 1140 0 628-511 1139-1139 1139zM5869 32790c661 0 1321 176 1904 527V1759H3966v31558c582-351 1243-527 1903-527zm-2419 1568V1243h4839v33115l-421-344c-1158-945-2840-945-3997 0l-421 344z"
          className="fill stroke1"
          style={{
            strokeWidth: 546.026,
          }}
        />
        <path
          d="M10192 29169c661 0 1322 156 1904 470V1759H8289v27880c581-314 1242-470 1903-470zm2420 1439-409-295c-1165-841-2856-841-4021 0l-409 295V1243h4839v29365z"
          className="fill stroke1"
          style={{
            strokeWidth: 546.026,
          }}
        />
        <path
          d="M14515 25127c672 0 1333 144 1904 410V1759h-3807v23778c571-266 1231-410 1903-410zm2419 1303-393-242c-1174-726-2878-726-4052 0l-393 242V1243h4838v25187z"
          className="fill stroke1"
          style={{
            strokeWidth: 546.026,
          }}
        />
        <path
          d="M16934 1759v19313c1172-455 2636-456 3808 0V1759h-3808zm4324 20127-375-188c-1185-598-2905-598-4091 0l-373 188V1243h4839v20643zM29903 1759v31558c1166-703 2642-703 3808 0V1759h-3808zm4323 32599-420-344c-1158-945-2840-945-3998 0l-420 344V1243h4838v33115z"
          className="fill stroke1"
          style={{
            strokeWidth: 546.026,
          }}
        />
        <path
          d="M27484 29169c660 0 1322 156 1903 470l1-27880h-3808v27880c582-314 1243-470 1904-470zm2419 1439-409-295c-1164-841-2856-841-4020 0l-410 295V1243h4839v29365z"
          className="fill stroke1"
          style={{
            strokeWidth: 546.026,
          }}
        />
        <path
          d="M23161 25127c672 0 1333 144 1903 410V1759h-3806v23778c570-266 1231-410 1903-410zm2419 1303-393-242c-1174-726-2878-726-4052 0l-393 242V1243h4838v25187zM36359 788c-344 0-624 281-624 625s280 624 624 624 624-280 624-624-280-625-624-625zm0 1764c-629 0-1140-511-1140-1139 0-629 511-1140 1140-1140 628 0 1139 511 1139 1140 1 628-511 1139-1139 1139z"
          className="fill stroke1"
          style={{
            strokeWidth: 546.026,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
